angular.module('zc.zenclerkS')
  .factory('ColorMeShop', ColorMeShop);

ColorMeShop.$inject = ['Api'];
function ColorMeShop(Api) {
  return {
    getLoginUrl,
  };

  function getLoginUrl() {
    return Api.get('/api/oauth/color_me_shop/login_url')
      .then(res => decodeURIComponent(res.data.login_url))
      .catch(error => console.error(error));
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/color_me_shop.service.js